import { sortArrayBy } from '@domain-group/javascript-utils'

import type { EntitiesState } from '@redux/entities'

type MapContactsAndUserObjectsParams = {
  contacts?: EntitiesState['contacts'],
  images: EntitiesState['images'],
  users?: EntitiesState['users'],
}

function mapContactsAndUserObjects(params: MapContactsAndUserObjectsParams) {
  const { contacts = {}, images, users = {} } = params

  const contactArray = Object.values(contacts).map((contact) => {
    const {
      email,
      first_name,
      full_name,
      id,
      last_name,
      mobile,
    } = contact

    return {
      email,
      entity_id: id,
      entity_type: 'Contact',
      first_name,
      full_name,
      last_name,
      mobile,
      type: 'Contact',
    }
  })

  const userArray = Object.values(users).map((user) => {
    const {
      actable,
      email,
      id,
      first_name,
      full_name,
      last_name,
      mobile_number,
    } = user
    // @ts-expect-error TS2339
    const image = images[user.image]

    return {
      email,
      // @ts-expect-error TS2339
      entity_id: actable?.id,
      // @ts-expect-error TS2339
      entity_type: actable?.type,
      first_name,
      full_name,
      id,
      image: {
        square: image?.thumb_url,
      },
      last_name,
      // @ts-expect-error TS2339
      mobile: mobile_number || actable?.mobile,
      // @ts-expect-error TS2339
      type: actable?.type,
    }
  })

  const merged = [...userArray, ...contactArray]

  return sortArrayBy(merged, 'asc', 'full_name')
}

export default mapContactsAndUserObjects
